import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SiteHeader from "./components/feature/SiteHeader";
import SiteFooter from "./components/feature/SiteFooter";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteHeader />
        <AppRoutes />
        <SiteFooter />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;